/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class Translation {

    public static translation(text:string):string {
        return NolimitApplication.apiPlugin.translations.translate(text);
    }
}